// Первый экран Mini App (макет «Mini App · первый экран», версия 67): развилка и нижняя кнопка.
// Витрины в Mini App нет: примеры и вопросы — ссылкой на сайт, если адрес сайта известен.
// Карточки направлений — как на главной сайта, но это выбор, а действие — нижняя кнопка;
// «Мои заказы» — в строке с логотипом, как в шапке сайта (Иван, 26.10.2026).
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { listOrders } from "../../api/endpoints";
import type { Direction } from "../../api/types";
import { useCatalog } from "../../app/queries";
import { doorsFor } from "../../site/directionDoors";
import { NEW_ORDER_PATH, SHOWCASE_PATH, directionClass } from "../../site/directionPaths";
import { useOpenExternalLink } from "../../telegram/channel";
import { MainAction } from "../../telegram/MainAction";
import { DoorChoice } from "../../ui/DirectionDoor";
import { Logo } from "../../ui/Logo";
import { NewsMark } from "../../ui/NewsMark";
import { TermsLine } from "../../ui/TermsLine";
import { ORDERS_KEY } from "../../app/queries";
import styles from "./MiniAppHome.module.css";

const ACTIONS: Record<Direction, string> = {
  miniature: "Создать миниатюру",
  gift: "Создать фигурку",
};

export function MiniAppHome() {
  const [chosen, setChosen] = useState<Direction>("miniature");
  const { data: catalog } = useCatalog();
  const { data: orders } = useQuery({ queryKey: ORDERS_KEY, queryFn: listOrders, refetchOnMount: "always" });
  const navigate = useNavigate();
  const openExternalLink = useOpenExternalLink();
  const siteUrl = catalog?.site_url ?? null;
  const hasOrders = orders !== undefined && orders.length > 0;
  const hasNews = orders?.some((order) => order.has_news) === true;
  return (
    <main className={`${styles.page} ${directionClass(chosen)}`}>
      <div className={styles.topRow}>
        <Logo gift={chosen === "gift"} />
        {hasOrders && (
          <Link to="/orders" className={styles.ordersLink}>
            Мои заказы
            {hasNews && <NewsMark />}
          </Link>
        )}
      </div>
      <div className={styles.intro}>
        <h1 className="h1">Фигурка с твоим лицом</h1>
        <p className="text small muted">
          Загрузи селфи и выбери, что делаем. Эскиз фигурки — бесплатно.
        </p>
      </div>
      <div className={styles.options} role="radiogroup" aria-label="Что делаем">
        {doorsFor(catalog).map((door) => (
          <DoorChoice
            key={door.direction}
            door={door}
            catalog={catalog}
            chosen={door.direction === chosen}
            onChoose={() => setChosen(door.direction)}
          />
        ))}
      </div>
      {siteUrl !== null && (
        <button
          type="button"
          className={styles.siteLink}
          onClick={() => openExternalLink(`${siteUrl.replace(/\/$/, "")}${SHOWCASE_PATH[chosen]}`)}
        >
          Примеры и вопросы — на сайте
        </button>
      )}
      <TermsLine />
      <MainAction text={ACTIONS[chosen]} onClick={() => navigate(NEW_ORDER_PATH[chosen])} />
    </main>
  );
}
